import { compose } from 'recompose';

import { withNamespaces } from 'react-i18next';
import Pin from './pin';

const enhance = compose(
  withNamespaces(['common']),
);
export default enhance(Pin);
